module.exports = __webpack_public_path__ + "static/media/0028.287fcfbf.jpg";